export default "__VITE_ASSET__B9kaqo1g__"